import PropTypes from "prop-types";
import styles from "./HighlightSection.module.css";

const items = [
  { icon: "/icon.svg",   label: "No Hidden Costs" },
  { icon: "/icon-1.svg", label: "Easy EMI" },
  { icon: "/icon-2.svg", label: "On-Time Delivery" },
  { icon: "/icon-3.svg", label: "Satisfied Customers" },
  { icon: "/icon-4.svg", label: "All Payments Accepted" },
  { icon: "/icon-5.svg", label: "Assured Warranty" },
  { icon: "/icon-6.svg", label: "Vastu Consultation" },
];

const HighlightSection = ({ className = "" }) => {
  return (
    <section className={[styles.highlights, className].join(" ")}>
      <div id="animation_linear_scroll" className={styles.bar}>
        {/* Duplicate items twice for seamless marquee loop */}
        <div className={styles.barTrack}>
          {[...items, ...items].map((item, i) => (
            <div key={i} className={styles.elementGroup}>
              <img className={styles.icon} loading="lazy" alt="" src={item.icon} />
              <h3 className={styles.childContainer}>{item.label}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

HighlightSection.propTypes = {
  className: PropTypes.string,
};

export default HighlightSection;
